import { formatCurrency } from '@if/core/utils'
import { MenuItem } from '@mui/material'
import { useUser } from '@src/providers/UserProvider'
import { EOperationStatus, EPaymentMethod } from '@src/types/constants'
import { CustomerPaymentOperation, OperationInformation } from '@src/types/loan/loan-operation'
import { CalendarSimulation } from '@src/types/loan/loan-simulation'
import { JSX, useMemo } from 'react'

const MAX_OPTIONS = 20
export const useValidPaymentOperationsForCalendarShift = (simulation: CalendarSimulation): JSX.Element[] => {
  const user = useUser()
  const canBypassAcpLock = user?.rights.canEditLockedPpaPayments ?? false
  return useMemo(() => {
    const options: JSX.Element[] = []
    const minimumDate = simulation.getNextValidActionDate(EPaymentMethod.PreAuthorizedPayment, canBypassAcpLock)
    for (let i = 0; i < simulation.customerPaymentOperations.length && options.length < MAX_OPTIONS; i++) {
      const operationInformation: OperationInformation<CustomerPaymentOperation> =
        simulation.customerPaymentOperations[i]

      if (
        operationInformation.operation.operationStatusId === EOperationStatus.Planned &&
        operationInformation.operation.effectiveDate >= minimumDate
      ) {
        options.push(
          <MenuItem
            key={operationInformation.operation.id}
            value={operationInformation.operation.effectiveDate.toString()}
          >
            {`${operationInformation.operation.effectiveDate.toString()} - ${formatCurrency(operationInformation.operation.amount)}`}
          </MenuItem>,
        )
      }
    }
    return options
  }, [simulation, canBypassAcpLock])
}
